import React from 'react';

const About: React.FC = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="py-16 bg-prata-antiga">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl font-bold text-azul-majestoso mb-6">
                Kronara: O Ciclo Eterno da Elegância
              </h1>
              <p className="mb-4">
                Kronara é mais do que uma marca, é um convite para explorar o eterno ciclo de beleza e sofisticação. 
                Inspirada na mitologia grega, na figura divina de Cronos, o deus do tempo, e no símbolo do Ouroboros, 
                uma representação da eternidade, Kronara captura a essência da continuidade e renovação.
              </p>
              <p className="mb-4">
                Cada criação Kronara é mais do que uma peça, é um portal para o mundo intemporal, 
                onde o tempo é como uma espiral sem fim, simbolizando a eternidade e a evolução constante. 
                O nome Kronara evoca uma narrativa única de elegância duradoura, conectando-se com a história, 
                a inovação e a beleza eterna.
              </p>
              <p>
                Descubra o ciclo eterno da elegância com Kronara, onde cada detalhe é uma expressão atemporal do extraordinário.
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src={process.env.PUBLIC_URL + 
                '/images/new/icon.svg'} 
                alt="Kronara" 
                className="max-w-full h-auto max-h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16">
        <div className="container">
          <h2 className="section-title">Palavras que Descrevem a Kronara</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 bg-prata-antiga rounded-lg text-center">
              <h3 className="text-xl font-bold text-azul-majestoso mb-4">Elegância</h3>
              <p>
                Reflete a sofisticação e o refinamento presentes nas criações da Kronara.
                Cada peça é concebida com atenção meticulosa aos detalhes, resultando em joias
                que emanam uma elegância atemporal.
              </p>
            </div>
            
            <div className="p-8 bg-prata-antiga rounded-lg text-center">
              <h3 className="text-xl font-bold text-azul-majestoso mb-4">Atemporalidade</h3>
              <p>
                Sugere que os produtos da Kronara transcendem as tendências passageiras, 
                permanecendo relevantes e elegantes ao longo do tempo. Nossas criações são
                projetadas para serem apreciadas por gerações.
              </p>
            </div>
            
            <div className="p-8 bg-prata-antiga rounded-lg text-center">
              <h3 className="text-xl font-bold text-azul-majestoso mb-4">Mistério</h3>
              <p>
                Evoca uma sensação de intriga e fascínio, sugerindo que há mais do que se vê 
                à primeira vista nas criações da Kronara. Cada peça conta uma história e convida
                o observador a descobrir seus segredos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Creator */}
      <section className="py-16 bg-prata-antiga">
        <div className="container">
          <h2 className="section-title mb-12">Conheça o Criador: Gustavo Bigelli</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <p className="mb-4">
                Gustavo fundou a Kronara em 2024 movido por um desejo antigo: criar algo verdadeiramente singular. 
                Durante seus estudos em design, foi apresentado ao universo das joias e seus processos manuais — 
                um encontro que despertou sua vontade de transformar ideias em matéria.
              </p>
              <p>
                Suas inspirações vêm de um imaginário que o acompanha desde a infância — mundos fantásticos, 
                histórias de poder e símbolos carregados de significado. É essa visão, entre o real e o atemporal, 
                que Gustavo busca imprimir em cada peça da Kronara.
              </p>
            </div>
            <div className="order-1 md:order-2 flex justify-center">
              <img 
                src={process.env.PUBLIC_URL + '/images/new/creator.jpg'} 
                alt="Gustavo Bigelli" 
                className="max-w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
